import DeclinePhoneCall from './lib/decline_phone_call';
import RoutingEventType from 'models/routing_event/routing_event_type';

export default class DeclineIncomingCall extends DeclinePhoneCall {
  _getRoutingEventType() {
    return RoutingEventType.DECLINED_OFFERED_CALL;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/phone_call/decline_incoming_call.js